<template>
  <!-- smp: single-month-planning -->
  <base-container class="smp" :fluid="true">
    <h2 class="lvl2-heading smp__capital">
      {{ planning.date.month }}
      <span>{{ planning.date.year }}</span>
    </h2>

    <SingleMonthPlanningTabs
      ref="singlemonthtab"
      :support="planning.supports"
      :supports-type="planning.supportsType"
      @planning-tab-change="handleSupportChange"
    />
    <!-- <div v-if="message" class="smp__meta">
      <span>{{ message }}</span>
      <ToggledCheckbox
        :checked="isGroupPlanning"
        @toggled-checkbox-change="handleGroupPlanningChange"
        label="Laisser mon groupement définir mon planning de diffusion"
      />
    </div> -->
    <template v-if="video">
      <PlannedVideoCard
        class="support-video"
        :video="video"
        @refreshPlanning="$emit('refreshPlanning')"
      />
    </template>
  </base-container>
</template>

<script>
import SingleMonthPlanningTabs from "./SingleMonthPlanningTabs"
// import ToggledCheckbox from "@/components/ToggledCheckbox"
// import VideoCardSlot from "./VideoCardSlot"
import PlannedVideoCard from "./PlannedVideoCard"
import { useGroup, addNewPlanning } from "@/api/plannings"
import { smpMixin } from "@/mixins"
import { Message } from "element-ui"

export default {
  props: {
    planning: {
      type: Object,
      required: true
    },
    video: {
      type: Object,
      required: true
    }
  },
  components: {
    SingleMonthPlanningTabs,
    // ToggledCheckbox,
    // VideoCardSlot,
    PlannedVideoCard
  },
  mixins: [smpMixin],
  watch: {
    planning: "setCurrentData"
  },
  methods: {
    async handleGroupPlanningChange(isGroupPlanning) {
      this.isGroupPlanning = isGroupPlanning
      const planningIsCreated = !!this.planning[this.currentSupport.id]
      const params = {
        month: this.planning.key,
        support_id: this.currentSupport.id,
        use_group: isGroupPlanning ? 1 : 0
      }
      try {
        if (planningIsCreated) {
          await useGroup(params)
          this.$emit("refreshPlanning")
        } else {
          await addNewPlanning({
            scheduled_at: this.planning.key,
            support_id: this.currentSupport.id,
            pharmacist_id: this.$store.getters.userInfo.id,
            use_group: isGroupPlanning ? 1 : 0
          })
          this.$emit("refreshPlanning")
        }
      } catch (err) {
        // Message.error("Oops! Groupement n'a pas été modifié")
        return
      }
      Message.success("Groupement modifié")
    },
    showConfirmValidationModal() {
      const validatePlanningVideos = {
        month: this.planning.key,
        support_id: this.currentSupport.id
      }

      this.$store.dispatch("openModal", {
        name: "confirm-planning-validation",
        payload: { validatePlanningVideos }
      })
    },
    handleSupportChange(tab) {
      this.currentVideo = tab.video
    }
  },
  data: () => ({
    currentVideo: null
  }),
  computed: {
    // NOTICE:
    // this is needed because we have to show
    // a diffrent message when the pharmacy doesn't
    // support a 'support'
    message() {
      return "N'oubliez pas de valider votre liste 10 jours avant \
        la date de diffusion. Après validation de votre liste, nous \
        les programmons dans votre pharmacie sur vos supports digitaux."
    },
    premiumEmptySots() {
      if (!this.currentSupport || !this.planning[this.currentSupport.id]) {
        return 4
      }
      return Math.abs(
        this.planning[this.currentSupport.id].premium_max_length -
          this.planning[this.currentSupport.id].premium_length
      )
    },
    freeEmptySots() {
      if (!this.currentSupport || !this.planning[this.currentSupport.id]) {
        return 6
      }
      return Math.abs(
        this.planning[this.currentSupport.id].free_max_length -
          this.planning[this.currentSupport.id].free_length
      )
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.planned-video-card {
  &.support-video {
    width: 450px;
    display: block;
    margin: 0 auto;
    & > div {
      height: 156px;
    }
  }
}
.smp {
  padding-bottom: 50px;
  &__meta {
    display: inline-flex;
    width: 100%;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin: 0 0 44px;
    & > span {
      max-width: 665px;
      margin-right: 10px;
    }
    & > .checkbox {
      margin-left: auto;
    }
  }
  &__group-planning {
    width: 100%;
    text-align: center;
    button {
      max-width: 475px;
    }
  }
  &__capital {
    text-transform: capitalize;
  }
}
</style>
